import {
  API_URI
} from "./config";
import fetch from './fetch';
import {
  getOSSParams
} from './tools';

const LOGIN_URI = `${API_URI}/login`;
export const login = (account, pwd) => {
  return fetch.post(LOGIN_URI, {
    account,
    pwd
  });
}

const GET_HOT_LABEL_URI = `${API_URI}/label/getHotLabel`;
export const getHotLabelList = () => {
  return fetch.get(GET_HOT_LABEL_URI);
};

const GET_LABEL_GROUP_LIST_URI = `${API_URI}/label/group`;
export const getLabelGroupList = (id = -1) => {
  return fetch.get(`${GET_LABEL_GROUP_LIST_URI}?group_id=${id}`);
};

const GET_CATEGORY_LIST_URI = `${API_URI}/folder/classify`;
export const getCategoryList = () => {
  return fetch.get(GET_CATEGORY_LIST_URI);
};

const GET_TYPE_LIST_URI = `${API_URI}/overview/getFileType`;
export const getTypeList = () => {
  return fetch.get(GET_TYPE_LIST_URI);
};

const GET_INDEX_LIST_URI = `${API_URI}/api/creative`;
export const getIndexList = params => {
  return fetch.get(`${GET_INDEX_LIST_URI}?page=${params.page}&pageSize=${params.pageSize}&labelList=${params.label}&datePreset=${params.time}&type=${params.type}&folderId=${params.category}&filter=${params.keyWords}`);
};

const GET_FOLDER_LIST_URI = `${API_URI}/folder/menu`;
export const getFolderList = id => {
  return fetch.get(`${GET_FOLDER_LIST_URI}/${id}`);
};

export const getFolderTreeList = () => {
  return fetch.get(GET_FOLDER_LIST_URI);
};

const GET_USE_LABEL_LIST_URI = `${API_URI}/label/getUseLabel`;
export const getUseLabelList = () => {
  return fetch.get(GET_USE_LABEL_LIST_URI);
};

const SEARCH_LABEL_LIST_URI = `${API_URI}/label`;
export const searchLabelList = keyWords => {
  return fetch.get(`${SEARCH_LABEL_LIST_URI}/${keyWords}`);
};

export const addLabel = params => {
  return fetch.post(SEARCH_LABEL_LIST_URI, params);
};

const GET_FILE_DETAIL_URI = `${API_URI}/overview/getFile`;
export const getFileDetail = id => {
  return fetch.get(`${GET_FILE_DETAIL_URI}/${id}`);
};

const ADD_LABEL_GROUP_URI = `${API_URI}/label/group`;
export const addLabelGroup = name => {
  return fetch.post(ADD_LABEL_GROUP_URI, {
    group_name: name
  });
};

export const editLabelGroup = params => {
  return fetch.put(ADD_LABEL_GROUP_URI, params);
};

export const deleteLabelGroup = id => {
  return fetch.delete(`${ADD_LABEL_GROUP_URI}/${id}`);
};

export const deleteLabel = ids => {
  return fetch.delete(`${SEARCH_LABEL_LIST_URI}/${ids}`);
};

export const updateLabelGroup = params => {
  return fetch.put(`${SEARCH_LABEL_LIST_URI}/updateGroup`, params);
};

const FILE_ADD_LABEL_URI = `${API_URI}/overview`;
export const fileAddLabel = params => {
  return fetch.post(FILE_ADD_LABEL_URI, params);
};

const DELETE_FILE_AND_FOLDER_URI = `${API_URI}/folder/menu`;
export const deleteFileAndFolder = params => {
  return fetch.delete(`${DELETE_FILE_AND_FOLDER_URI}?menu_ids=${params.folderIds}&file_ids=${params.fileIds}`);
};

const GET_OSS_CONFIG_URI = `${API_URI}/oss`;
export const getOSSConfig = () => {
  return fetch.get(GET_OSS_CONFIG_URI);
};

export const uploadFileToOSS = (params, file, folderIndex, fileName, callback) => {
  const OSS_PARAMS = getOSSParams(params.accessKeyId, params.accessKeySecret);
  const uploadParams = {
    key: folderIndex + fileName,
    ...OSS_PARAMS,
    file: file
  };

  const fd = new FormData();
  for (let i in uploadParams) {
    fd.append(i, uploadParams[i]);
  }

  return fetch.post(`http://${params.bucketName}.${params.endpoint}`, fd, {}, callback);
};

const WRITE_UPLOAD_LOG_URI = `${API_URI}/folder/upload`;
export const writeUploadLog = filePath => {
  return fetch.post(WRITE_UPLOAD_LOG_URI, {
    urls: [filePath]
  });
};

const DOWNLOAD_FILE_URI = `${API_URI}/folder/download`;
export const downloadFile = id => {
  return fetch.get(`${DOWNLOAD_FILE_URI}/${id}`);
};

export const getAllFileList = () => {
  return fetch.get(`${FILE_ADD_LABEL_URI}?page=1&pageSize=999999&labelList=&fileSuf=&folderId=`);
};

const GET_HOT_TAG_LIST_URI = `/label/getHotLabel`;
export const getHotTagList = () => {
  return fetch.get(`${API_URI}${GET_HOT_TAG_LIST_URI}`);
};

const ADD_HOT_TAG_URI = `/label/hot`;
export const addHotTag = name => {
  const params = {};
  if (typeof name === 'number') {
    params.label_id = name;
  } else {
    params.label_name = name;
  }
  return fetch.post(`${API_URI}${ADD_HOT_TAG_URI}`, params);
};

export const deleteHotTag = ids => {
  return fetch.delete(`${API_URI}${ADD_HOT_TAG_URI}/${ids}`);
};

const CHANGE_FILE_NAME_URI = `/overview/file`;
export const changeFileName = params => {
  return fetch.post(`${API_URI}${CHANGE_FILE_NAME_URI}`, params);
};


// 登录接口地址
const LOGIN_URI_NEW = `${API_URI}/login`;
// 用户登录
export const userLogin = ({
  userName = '',
  password = '',
  accessToken = '',
  platform = 1
}) => {
  // 免登录 accessToken
  const urlSuffix = userName ?
    `?username=${userName}&password=${password}&platform=${platform}&accessToken=` :
    `?platform=${platform}&accessToken=${accessToken}`

  return new Promise((resolve, reject) => {
    fetch.post(LOGIN_URI_NEW + urlSuffix, {}).then(res => {
      resolve(res);
    }, res => {
      reject(res);
    });
  });
};


// 发送短信验证码地址
const SEND_SMS_CODE_URI = `${API_URI}/user/sms`;
// 发送短信验证码
export const sendSmsCode = phone => {
  return fetch.get(`${SEND_SMS_CODE_URI}?phone=${phone}`);
};


// 检测验证码地址
const CHECK_SMS_CODE_URI = `${API_URI}/user/checkCode`;
// 检验短信验证码
export const checkSmsCode = params => {
  return fetch.get(`${CHECK_SMS_CODE_URI}?phone=${params.phone}&code=${params.code}`);
};


// 修改密码
const CHANGE_PASSWORD_URI = `${API_URI}/user/changePassword`;
export const changePassword = params => {
  return fetch.put(`${CHANGE_PASSWORD_URI}`, params);
};


// 注册接口地址
const REGISTER_URL = `${API_URI}/user/signIn`;
// 用户注册
export const userReigstration = params => {
  return fetch.post(REGISTER_URL, params)
}

// 检测用户名地址
const CHECK_USERNAME = `${API_URI}/user/checkUserName`;
// 检测用户名
export const checkUserName = params => {
  return fetch.get(`${CHECK_USERNAME}?userName=${params.userName}`)
}

const GET_COMMON_TAG_LIST_URI = `${API_URI}/label/getUseLabel`;
export const getCommonTagList = () => {
  return fetch.get(GET_COMMON_TAG_LIST_URI);
};

const ADD_COMMON_TAG_URI = `${API_URI}/label/common`;
export const addCommonTag = name => {
  const params = {};
  if (typeof name === 'number') {
    params.label_id = name;
  } else {
    params.label_name = name;
  }
  return fetch.post(`${ADD_COMMON_TAG_URI}`, params);
};

export const deleteCommonTag = ids => {
  return fetch.delete(`${ADD_COMMON_TAG_URI}/${ids}`);
};

const GET_SIMILAR_FILE_LIST_URI = `${API_URI}/overview/similarFileList`;
export const getSimilarFileList = ({
  id,
  page = 1,
  pageSize = 20
}) => {
  return fetch.get(`${GET_SIMILAR_FILE_LIST_URI}?file_id=${id}&page=${page}&pageSize=${pageSize}`);
};

const GET_MENU_LIST_URI = `${API_URI}/user/getMenusByUserId`;
export const getMenuList = () => {
  return fetch.get(`${GET_MENU_LIST_URI}?systemFlag=3`);
};

const SECURITY_FILE_URI = `${API_URI}/overview/secrecy`;
export const securityFile = params => {
  return fetch.post(SECURITY_FILE_URI, params);
};


// ----素材库----
const materialLibrarys = {
  delete: `${API_URI}/file/manage/delete`,
  getRoot: `${API_URI}/file/manage/root`,
  getDir: `${API_URI}/file/manage/dir`,
  upload: `${API_URI}/file/manage/upload`,
  create: `${API_URI}/file/manage/dir/create`,
  ossConfig: `${API_URI}/oss/materialLibrary`,
  uploadUrl: `${API_URI}/file/manage/document/upload/urls`,
  project: `${API_URI}/file/manage/project`,
  account: `${API_URI}/file/manage/project/act`,
  toChannel: `${API_URI}/file/manage/synchronizeMaterialToChannel`,
}

export const materialLibrarysHandler = {
  getOssConfig() {
    return fetch.get(materialLibrarys.ossConfig)
  },
  getRoot(params) {
    return fetch.get(`${materialLibrarys.getRoot}?projectId=${params}`)
  },
  getDir(params) {
    return fetch.get(`${materialLibrarys.getDir}?dirId=${params}`)
  },
  deleteFiles(params) {
    return fetch.post(`${materialLibrarys.delete}`, params)
  },
  upload(params) {
    return fetch.post(materialLibrarys.upload, params)
  },
  create(params) {
    return fetch.get(`${materialLibrarys.create}?dirName=${params.dirName}&parentId=${params.parentId}`)
  },
  uploadUrl(params) {
    return fetch.post(materialLibrarys.uploadUrl, params)
  },
  getProject() {
    return fetch.get(materialLibrarys.project)
  },
  getAccount(params) {
    return fetch.get(`${materialLibrarys.account}?projectId=${params.projectId}&platform=${params.platform}`)
  },
  toChannel(params) {
    return fetch.post(materialLibrarys.toChannel, params)
  }
}

const GET_THIRD_PARTY_LIST_URI = `${API_URI}/material/external`;

export const getThirdPartyList = params => {
  return fetch.get(`${GET_THIRD_PARTY_LIST_URI}?orderType=${params.sortType}&startDate=${params.startDate}&endDate=${params.endDate}&pageNumber=${params.page}&pageSize=20&origin=${params.origin}`);
};

const SAVE_THIRD_PARTY_TO_MY_DATABASE_URI = `${API_URI}/material/external/copyToCustomerLibrary`;
export const saveThirdPartyToMyDataBase = params => {
  return fetch.post(SAVE_THIRD_PARTY_TO_MY_DATABASE_URI, params);
};

const GET_VIDEO_BLOB_URI = `${API_URI}/material/external/transcoding`;
export const getVideoBlob = id => {
  return fetch.get(`${GET_VIDEO_BLOB_URI}?id=${id}`, {}, 'blob');
};

const CANCEL_FAVOR_URI = `${API_URI}/material/external/cancelCollect`;
export const cancelFavor = ids => {
  return fetch.post(CANCEL_FAVOR_URI, ids);
};

const DOWNLOAD_THIRD_PARTY_FILE_URI = `${API_URI}/material/external/stream`;
export const downloadThirdPartyFile = id => {
  return fetch.get(`${DOWNLOAD_THIRD_PARTY_FILE_URI}?kuaiShouId=${id}`, {}, 'blob');
};

// 通过流下载文件
const DOWNLOAD_FILE_BY_STREAM = `${API_URI}/file/manage/download`
export const downloadFileByStream = docId => fetch.get(`${DOWNLOAD_FILE_BY_STREAM}?docId=${docId}`, {}, 'blob')

const GET_VIDEO_DETAIL_URI = `${API_URI}/material/external/video?videoId=`;
export const getVideoDetail = id => fetch.get(`${GET_VIDEO_DETAIL_URI}${id}`);
